import React from 'react';
import { Ellipsis } from 'lucide-react';

// PreviewHeader Component
const PostPreviewHeader = ({ layout, platform, logo, businessName, isMobile }) => {
  if (layout === 'story') {
    return (
      <div className='absolute top-0 left-0 right-0 z-10 p-2 md:p-3 bg-gradient-to-b from-black/60 to-transparent'>
        {/* Progress Bar */}
        <div className='flex gap-1 mb-2'>
          <div className='flex-1 h-0.5 bg-white/30 rounded-full'>
            <div className='h-full w-1/2 bg-white rounded-full' />
          </div>
        </div>
      </div>
    );
  }

  // Feed layout header — mimics real social platform chrome (intentionally light)
  return (
    <div className='p-2 md:p-3 flex-shrink-0' style={{ borderBottom: '1px solid #dbdbdb' }}>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          {platform === 'instagram' ? (
            <div className='w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 p-[2px]'>
              <div className='w-full h-full rounded-full bg-gray-800 flex items-center justify-center overflow-hidden'>
                {logo ? (
                  <img
                    src={logo}
                    alt='Logo'
                    className='w-full h-full object-cover rounded-full'
                    onError={(e) => {
                      e.target.src = 'https://placehold.co/100x100/png?text=Logo';
                    }}
                  />
                ) : (
                  <span className='text-white text-xs md:text-sm font-bold'>B</span>
                )}
              </div>
            </div>
          ) : (
            <div className='w-6 h-6 md:w-8 md:h-8 rounded-full bg-blue-600 flex items-center justify-center overflow-hidden'>
              {logo ? (
                <img
                  src={logo}
                  alt='Logo'
                  className='w-full h-full object-cover rounded-full'
                  onError={(e) => {
                    e.target.src = 'https://placehold.co/100x100/png?text=Logo';
                  }}
                />
              ) : (
                <span className='text-white text-xs md:text-sm font-bold'>B</span>
              )}
            </div>
          )}
          <div className='flex flex-col items-start gap-0'>
            <span
              className='font-bold p-0 m-0'
              style={{ fontSize: isMobile ? '8px' : '12px', color: '#262626' }}
            >
              {businessName}
            </span>
            {platform === 'facebook' && (
              <span
                className='p-0 m-0'
                style={{ fontSize: isMobile ? '6px' : '8px', color: '#65676b' }}
              >
                Just now · 🌐
              </span>
            )}
          </div>
        </div>
        <Ellipsis className='w-5 h-5 md:w-6 md:h-6' style={{ color: '#262626' }} />
      </div>
    </div>
  );
};

export default PostPreviewHeader;
